//存放常量-全局管理
export const SET_RANK = 'SET_RANK';
export const SET_RANK2 = 'SET_RANK2';
export const SET_URL_INFO = 'set_url_info';
export const SET_PROJECT_INFO = 'set_project_info';
export const GET_MYMESSAGE_INFO = 'get_mymessage_info';
export const GET_MESSAGE_STATUS = "get_message_status"
export const SET_FILE_INFO = 'set_files_info';
export const SET_FILE_TASK_INFO = 'set_files_task_info';
export const SET_TASK_INFO = 'set_task_info';
export const SET_ELE_STATUS = 'set_ele_status';
export const SET_TASK_CONTENT = 'set_task_content';
export const SET_TASK_PROGRESS = 'set_task_progress';
export const SET_OPERATION_SIGN = 'set_operation_sign';
export const SET_CURRENT_SENTENCE_ID = 'set_current_sentence_id';
export const SET_RIGHT_MOUSE_POSITION = 'set_right_mouse_position';
export const SET_FILE_PREVIEW_CONTENT = 'set_file_preview_content';
export const SET_TASK_QACHECK_INFO = 'set_task_QAcheck_info';
export const SET_FRAGMENT_QACHECK_INFO = 'set_fragment_QAcheck_info';
export const SET_SUGGEST_REMARKS_STATE = 'set_suggest_remarks_state';
export const SET_EDITOR_PATTERN_INFO = 'set_editor_pattern_info';
export const SET_FONT_SIZE_INFO = 'set_font_size_info';
export const SET_THEME_INFO = 'set_theme_info';
export const SET_SOURCEEDITOR_STATUS = 'set_sourceeditor_status';
export const SET_TARGETEDITOR_STATUS = 'set_targeteditor_status';
export const SET_SOURCEEDITOR_ISSTATUS = 'set_targeteditor_isstatus';
export const SET_SEARCH_INFO = 'set_search_info';
export const SET_MODIFY_RECORD_INFO = 'set_modify_record_info';
export const SET_MODIFY_RECORD_PARAMS_INFO = 'set_modify_record_params_info';
export const SET_PREVIEW_PARAMS_INFO = 'set_preview_params_info';
export const SET_QA_STATE_INFO = 'set_QA_state_info';
export const SET_TASK_CONTENT_PARAMS = 'set_task_content_params';
export const SET_FRAGMENT_TERM_INFO = 'set_fragment_term_info';
export const SET_FRAGMENT_MEMORY_INFO = 'set_fragment_Memory_info';
export const SET_CURRENT_REMARKS_INFO = 'set_current_remarks_info';
export const SET_TRANSLATE_DICT_LIST_INFO = 'set_translate_dict_list_info';
export const SET_TEMP_SENTENCE_ID_INFO = 'set_temp_sentence_id_info';
export const SET_EDITOR_RIGHT_ACTIVE_NAME_INFO = 'set_editor_right_active_name_info';
export const SET_HISTORY_RECOVER_DATA_INFO = 'set_history_recover_data_info';
export const SET_HISTORY_RECOVERY_DATA_INFO = 'set_history_recovery_data_info';
export const RECORD_CURSOR_POSITION_INFO = 'Record_cursor_position_info';
export const RECORD_CURSOR_POSITION_TARGET_INFO = 'Record_cursor_position_target_info';
export const SET_UPDATE_STATE_INFO = 'set_updata_state_info';
export const SET_LOADING_INFO = 'set_loading_info';
export const CANCEL_LOADING_INFO = 'cancel_loading_info';
export const SET_USER_INFO = 'set_user_info';
export const SET_UPDATA_FRAGMENT_TYPE = 'set_updata_fragment_type';
export const SET_EDITOR_BOTTOM_ACTIVE_NAME = 'set_editor_bottom_active_name';
export const SET_TERM = 'set_term';
export const SET_PREVIEW_INFO = 'set_preview_info';
export const SET_THIRD = 'set_third';
export const SET_WORD_PREVIEW = 'set_word_Preview';
export const SET_APPOINT_PREVIEW = 'set_appoint_preview';
export const SET_SENT_COUNT_INFO = 'set_sent_count_info';
// export const SET_COMPARISON_MODE = "set_comparison_mode";
// export const SET_COMPARISON_LIST = "set_comparison_list"
export const SET_THEME_LIST = 'set_theme_list';
export const UPDATE_TEMPORARY_TERM_LIST = 'update_temporary_term_list'
export const UPDATA_IMPORT_OPTION = 'updata_import_option'
export const UPDATE_CURRENT_VIEW_MODE = 'update_current_view_mode'

export const UPDATE_EVALUATION_RESULTS = 'update_evaluation_results'
export const UPDATE_FRAGMENT_SENTENCE_MT = 'update_fragment_sentence_mt'
export const GET_COUNTTARGET_SENTIS = 'get_counttarget_sentis'
export const SET_EDITORDATA_LIST = "set_editordata_list"

